<div class="alerts-container">
  @for (alert of shownAlerts; track alert; let index = $index) {
    <div
      class="alert alert-dismissible alert-border-left alert-fill alert-close fade show"
      role="alert"
         [ngClass]="{
            'alert-success': alert.type === 'success',
            'alert-info': alert.type === 'info',
            'alert-danger': alert.type === 'error',
            'alert-warning': alert.type === 'warning'
         }"
      (click)="onDismissClick(index)"
      @fadeInOut>
      <span class="icon-container">
        @switch (alert.type) {
          @case ('success') {
            <i class="fa fa-check"></i>
          }
          @case ('info') {
            <i class="fa fa-info"></i>
          }
          @case ('error') {
            <i class="fa fa-exclamation-circle"></i>
          }
          @case ('warning') {
            <i class="fa fa-exclamation-triangle"></i>
          }
        }
      </span>
      <h4 class="alert-heading">{{ alert.title }}</h4>
      <p>{{ alert.message }}</p>
    </div>
  }
</div>
